/**
 * XGrid 的通用导入头
 */

import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
	formatter as fmt
} from "@/utils/ebase-formatter"
import api from '@/services/api'
import {loadBaseCodeData, loadAreaTreeData, dealTreeNoChild} from "@/services/baseCodeSource";

const fac = XGrid.factory;
import XEUtils from "xe-utils";
import {validatorPhone, validatorPhoneNoRequire, validatorEmail, validatorEmailNoRequire, jsPrint} from '@/utils/util'
import {getSyncJson} from "@/utils/request";
import {mapState} from "vuex";

export {
	XGrid,
	GridMixin,
	fmt,
	api,
	fac,
	loadBaseCodeData,
	loadAreaTreeData,
	dealTreeNoChild,
	XEUtils,
	validatorPhone,
	validatorPhoneNoRequire,
	validatorEmail,
	validatorEmailNoRequire,
	jsPrint,
	getSyncJson,
	mapState
}